<!-- 资产配置 -->
<template>
  <div class="el-AssetAllocation">
    <el-row class="content_block mb30">
      <TitleInfo title="资产配置" :titleImg="zichan"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-row>
          <el-table
            :data="tableData"
            :span-method="arraySpanMethod"
            border
            style="width: 100%">
            <el-table-column prop="name" header-align="center" align="center" label="类型" width="120">
              <template slot-scope="scope">
                <p style="writing-mode: lr-tb;width: 20px;margin: 0 auto;">
                  <el-image class="user_img" :src="geren"></el-image>
                  个人投资账户
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="name" header-align="left" align="left" label="账户" width="220">
              <template slot-scope="scope">
                <span v-if="accountTypeMap[scope.row.name] != '现金账户' && accountTypeMap[scope.row.name] != '银行账户'" style="margin-left:20px ;">&nbsp;</span>
                {{ accountTypeMap[scope.row.name] }}
              </template>
            </el-table-column>
            <el-table-column prop="initialCapital" header-align="center" align="center" label="初始资金">
              <template slot-scope="scope">
                {{numberFormat(scope.row.initialCapital || 0)}}
              </template>
            </el-table-column>
            <el-table-column prop="initialInvestmentCapital" header-align="center" align="center" label="期初投资资金">
              <template slot-scope="scope">
                {{numberFormat(scope.row.initialInvestmentCapital || 0)}}
              </template>
            </el-table-column>
            <el-table-column prop="transferinAmount" header-align="center" align="center" label="转入资金">
              <template slot-scope="scope">
                {{numberFormat(scope.row.transferinAmount || 0)}}
              </template>
            </el-table-column>
            <el-table-column prop="transferOutAmount" header-align="center" align="center" label="转出资金">
              <template slot-scope="scope">
                {{numberFormat(scope.row.transferOutAmount || 0)}}
              </template>
            </el-table-column>
            <el-table-column prop="availableFunds" header-align="center" align="center" label="可用资金">
              <template slot-scope="scope">
                {{numberFormat(scope.row.availableFunds || 0)}}
              </template>
            </el-table-column>
            <el-table-column prop="intoAccount" header-align="center" align="center" label="转入账户" class-name="AmountValue">
              <template slot-scope="scope">
                <template v-if="accountTypeMap[scope.row.name] == '银行账户'">
                  <el-select v-model="scope.row.value" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.applicationId"
                        :label="accountTypeMap[item.name]"
                        :value="item.applicationId">
                      </el-option>
                    </el-select>
                </template>
                <template v-else>
                  银行账户
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="zzje" header-align="center" align="center" label="转账金额" class-name="AmountValue">
              <template slot-scope="scope">
                <el-input v-model="scope.row.input"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="120">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" @click="allOpenAccount(scope.row)">确定</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-table
            :data="noticeList"
            :span-method="arraySpanMethod"
            border
            style="width: 100%">
            <el-table-column prop="name" header-align="center" align="center" label="类型" width="120">
              <template slot-scope="scope">
                <p style="writing-mode: lr-tb;width: 20px;margin: 0 auto;">
                  <el-image class="user_img" :src="jigou"></el-image>
                  企业投资账户
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="zh" header-align="left" align="left" label="账户" width="220">
              <template slot-scope="scope">
                <span v-if="accountTypeMap[scope.row.name] != '现金账户' && accountTypeMap[scope.row.name] != '银行账户'" style="margin-left:20px ;">&nbsp;</span>
                {{accountTypeMap[scope.row.name]}}
              </template>
            </el-table-column>
            <el-table-column prop="initialCapital" header-align="center" align="center" label="初始资金">
              <template slot-scope="scope">
                {{numberFormat(scope.row.initialCapital || 0)}}
              </template>
            </el-table-column>
            <el-table-column prop="initialInvestmentCapital" header-align="center" align="center" label="期初投资资金">
              <template slot-scope="scope">
                {{numberFormat(scope.row.initialInvestmentCapital || 0)}}
              </template>
            </el-table-column>
            <el-table-column prop="transferinAmount" header-align="center" align="center" label="转入资金">
              <template slot-scope="scope">
                {{numberFormat(scope.row.transferinAmount || 0)}}
              </template>
            </el-table-column>
            <el-table-column prop="transferOutAmount" header-align="center" align="center" label="转出资金">
              <template slot-scope="scope">
                {{numberFormat(scope.row.transferOutAmount || 0)}}
              </template>
            </el-table-column>
            <el-table-column prop="availableFunds" header-align="center" align="center" label="可用资金">
              <template slot-scope="scope">
                {{numberFormat(scope.row.availableFunds || 0)}}
              </template>
            </el-table-column>
            <el-table-column prop="intoAccount" header-align="center" align="center" label="转入账户">
              <template slot-scope="scope">
                <template v-if="accountTypeMap[scope.row.name] == '银行账户'">
                  <el-select v-model="scope.row.value" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.applicationId"
                        :label="accountTypeMap[item.name]"
                        :value="item.applicationId">
                      </el-option>
                    </el-select>
                </template>
                <template v-else>
                  银行账户
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="zzje" header-align="center" align="center" label="转账金额">
              <template slot-scope="scope">
                <el-input v-model="scope.row.input"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="120">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" disabled @click="allOpenAccount">确定</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-row style="padding: 5px 20px;border: 1px solid #E5E5E5;border-bottom: none;">
            <el-image  style="float: left;width: 20px;height: 20px;;margin: 10px 10px 0 0;" :src="jilu"></el-image>
            <span>转账记录</span>
            <el-date-picker
              v-model="value1"
              style="margin-left: 20px;"  
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              @change="getPageList"
              >
            </el-date-picker>
          </el-row>
          <el-table
            :data="recordList"
            border
            style="width: 100%">
            <el-table-column prop="createTime" header-align="center" align="center" label="时间"> </el-table-column>
            <el-table-column prop="transferType" header-align="center" align="center" label="转账账户类型"> </el-table-column>
            <el-table-column prop="zczh" header-align="center" align="center" label="转出账户"> </el-table-column>
            <el-table-column prop="intoAccount" header-align="center" align="center" label="转入账户"> </el-table-column>
            <el-table-column prop="transactionAmount" header-align="center" align="center" label="金额">
              <template slot-scope="scope">
                {{numberFormat(scope.row.transactionAmount || 0)}}
              </template> 
            </el-table-column>
            <el-table-column prop="messageAcceptState" header-align="center" align="center" label="状态" width="120">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false">进行中</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import { numberFormat } from '@/common/ulit.js'
import TitleInfo from "@/components/TitleInfo";	//页面头部
import jQuery from 'jquery';
export default {
  name: "AssetAllocation",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      zichan:require("../../images/asset/zichan@2x.png"),
      geren:require("../../images/asset/geren@2x.png"),
      jigou:require("../../images/asset/jigou@2x.png"),
      jilu:require("../../images/asset/jilu@2x.png"),
      identityInfo:this.$ls.get(this.$getKeyInfo("identityInfo")) || {},
      tableData:[],
      noticeList:[],
      recordList:[ //记录数据
        // {sj:"2022-09-06",zzzhlx:"个人投资账户",zczh:"/",zrzh:"/",je:390},
        // {sj:"2022-08-06",zzzhlx:"个人投资账户",zczh:"/",zrzh:"/",je:418},
      ],
      value1:"",
      options: [{
        value: '选项1',
        label: '现金账户'
      }, {
        value: '选项2',
        label: '网络融资账户'
      }, {
        value: '选项3',
        label: '众筹账户'
      }, {
        value: '选项4',
        label: '股票基金投资账户'
      }, {
        value: '选项5',
        label: '期货投资账户'
      }, {
        value: '选项6',
        label: '股权投资账户'
      }, {
        value: '选项7',
        label: '天择区块链实验教学系统'
      }, {
        value: '选项8',
        label: '供应链金融教学软件'
      }],
      timeIn:null,
      accountTypeMap:{
        CASH_ACCOUNT:"现金账户",
        BANK_ACCOUNT:"银行账户",
        P2P_ACCOUNT:"网络融资账户",
        CROWDFUNDING_ACCOUNT:"众筹账户",
        EQUITY_FUND_INVESTMENT_ACCOUNT:"股票基金投资账户",
        FUTURES_INVESTMENT_ACCOUNT:"期货投资账户",
        EQUITY_INVESTMENT_ACCOUNT:"股权投资账户",
        EQUITY_FUND_QUANTITATIVE_TRADING_ACCOUNT:"量化交易账户（股票基金）",
        FUTURES_QUANTITATIVE_TRADING_ACCOUNT:"量化交易账户（期货）",
        BLOCKCHAIN_ASSET_ACCOUNT:"区块链资产账户",
        OPTIONS_INVESTMENT_ACCOUNT:"期权投资账户",
        MARGIN_ACCOUNT:"融资融券账户",
        FOREX_INVESTMENT_ACCOUNT:"外汇投资账户",
        TRUST_ACCOUNT:"信托账户",
        INSURANCE_ACCOUNT:"保险账户",
        SUPPLY_CHAIN_ASSET_ACCOUNT:"供应链资产账户",
        FINANCIAL_ACCOUNT:"理财账户",
      }
    };
  },
  created() {

  },
  mounted() {
    this.getInfo();
    this.getCapitalAccount();
    this.getPageList(); //资产配置转账记录
    //this.addSystem();
  },
  methods: {
    numberFormat,
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 16 === 0) {
          return {
            rowspan: 16,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    getInfo(){ //获取数据
      this.$get("/api/studentAccountAssetAllocation/getList.do",{studentId:this.identityInfo.studentId,isInstitution:1}).then((ret) =>{
        if(ret.code == 0){
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
      this.$get("/api/studentAccountAssetAllocation/getList.do",{studentId:this.identityInfo.studentId,isInstitution:2}).then((ret) =>{
        if(ret.code == 0){
          this.noticeList= ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    allOpenAccount(val){ //转账
       let value=''
       if(val.hasOwnProperty('value')){
        value=val.value
       }else{
        this.tableData.forEach(item=>{
          if(item.name=='BANK_ACCOUNT'){
            value=item.applicationId
          }
        })
       }
      let param = {
        studentId:this.identityInfo.studentId,
        toAccountsApplicationId:value,//（转入账户）
        outAccountsApplicationId:val.applicationId,//（转出账户）
        money:val.input,//（金额）
      }
      this.$post("/api/studentAccountAssetAllocation/allOpenAccount.do",param).then((ret) =>{
        if(ret.code == 0){
          this.tableData = ret.data;
          this.getInfo()
          
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getCapitalAccount(){ //选择转入账号
      this.$get("/api/studentAccountAssetAllocation/getCapitalAccount.do",{studentId:this.identityInfo.studentId}).then((ret) =>{
        if(ret.code == 0){
          this.options = ret.data || [];
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getPageList(){ //转账记录List
      let param = {
        studentId:this.identityInfo.studentId,
        startTime:this.value1[0],
        endTime:this.value1[1],
      }
      this.$post("/api/studentAccountTradingRecordSheet/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.recordList = ret.data || [];
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"资产配置",//一级名称
          secondName:"资产配置",//二级名称
          useDuration:timeNum / 1000 / 60 //单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    },
   
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-AssetAllocation{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
    // 自定义表格头部颜色和边框颜色
    .el-table__header th{
      background-color: #EFF2F7;
    }
    .el-table--border, .el-table--group,.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
      border-color: #E5E5E5;
      font-size: 12px;
    }
    th.el-table__cell{
      padding: 5px 0;
    }
    td.el-table__cell{
      padding: 0;
    }
    .el-input__inner{
      height: 30px;
      line-height: 30px;
    }
    .el-link{
      font-size: 12px;
    }
    .el-date-editor .el-range__icon,.el-date-editor .el-range-separator{
      line-height: 23px;
    }
    .el-input__icon{
      line-height: 23px;
    }
  }
.AmountValue{
    padding: 0;
    .cell{
      padding: 0 !important;
      .el-input__inner{
        border-radius: 0;
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/asset/AssetAllocation.vue